import { Option, SelectionModel } from "./types";

export class DefaultSelectionModel implements SelectionModel {
    // eslint-disable-next-line
    constructor() {}
    // eslint-disable-next-line
    private _selected: Option[] = [];

    get value(): Option[] {
        return this._selected;
    }

    select(item: Option, multiple: boolean, groupAsModel: boolean) {
        item.selected = true;

        if (!item.children) {
            this._selected.push(item);
        }

        if (multiple) {
            if (item.parent) {
                this._setParentState(item.parent);
            } else if (item.children) {
                item.mixed = false;
                this._setChildrenSelectedState(item.children, true);
                this._removeChildren(item);
                if (groupAsModel && this._activeChildren(item)) {
                    this._selected = [...this._selected.filter((x) => x.parent !== item), item];
                } else {
                    this._selected = [...this._selected, ...item.children.filter((x) => !x.disabled)];
                }
            }
        }
    }

    unselect(item: Option, multiple: boolean) {
        this._selected = this._selected.filter((x) => x !== item);
        item.selected = false;

        if (multiple) {
            // eslint-disable-next-line
            if (item.parent && item.parent.selected) {
                const children = item.parent.children;
                this._removeParent(item.parent);
                this._removeChildren(item.parent);
                this._selected.push(...children.filter((x) => x !== item && !x.disabled));
            } else if (item.children) {
                this._setChildrenSelectedState(item.children, false);
                this._removeChildren(item);
            }

            if (item.parent) {
                this._setParentState(item.parent);
            }
        }
    }

    clear(keepDisabled: boolean) {
        this._selected = keepDisabled ? this._selected.filter((x) => x.disabled) : [];
    }

    private _setChildrenSelectedState(children: Option[], selected: boolean) {
        for (const child of children) {
            if (child.disabled) {
                continue;
            }
            child.selected = selected;
        }
    }

    private _removeChildren(parent: Option) {
        this._selected = [
            ...this._selected.filter((x) => x.parent !== parent),
            ...parent.children.filter((x) => x.parent === parent && x.disabled && x.selected)
        ];
    }

    private _removeParent(parent: Option) {
        this._selected = this._selected.filter((x) => x !== parent);
    }

    private _activeChildren(item: Option): boolean {
        return item.children.every((x) => !x.disabled || x.selected);
    }

    private _setParentState(parent: Option) {
        const childrenCount = parent.children.length;
        const selectedCount = parent.children.filter((x) => x.selected).length;
        parent.mixed = selectedCount > 0 && selectedCount < childrenCount;
        parent.selected = selectedCount === childrenCount;
    }
}
